import React from "react";
import { useRoundById } from "../../../context/RoundContext";
import { ProjectInCart } from "./ProjectInCart";
import { matchingEstimatesToText, useMatchingEstimates } from "../../../hooks/matchingEstimate";
import { getAddress, parseUnits, zeroAddress } from "viem";
import { useAccount } from "wagmi";
import { useCartStorage } from "../../../store";
import { Skeleton } from "@chakra-ui/react";
import { BoltIcon } from "@heroicons/react/24/outline";
import { getFormattedRoundId } from "../../common/utils/utils";
import { PassportWidget } from "../../common/PassportWidget";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function RoundInCart(props) {
  var _round$roundMetadata, _round$roundMetadata2, _round$roundMetadata$, _round$roundMetadata3, _round$id, _round$roundMetadata4;
  const round = useRoundById(props.roundCart[0].chainId, props.roundCart[0].roundId).round;
  const isSybilDefenseEnabled = (round === null || round === void 0 || (_round$roundMetadata = round.roundMetadata) === null || _round$roundMetadata === void 0 || (_round$roundMetadata = _round$roundMetadata.quadraticFundingConfig) === null || _round$roundMetadata === void 0 ? void 0 : _round$roundMetadata.sybilDefense) === true || (round === null || round === void 0 || (_round$roundMetadata2 = round.roundMetadata) === null || _round$roundMetadata2 === void 0 || (_round$roundMetadata2 = _round$roundMetadata2.quadraticFundingConfig) === null || _round$roundMetadata2 === void 0 ? void 0 : _round$roundMetadata2.sybilDefense) !== "none";
  const minDonationThresholdAmount = (_round$roundMetadata$ = round === null || round === void 0 || (_round$roundMetadata3 = round.roundMetadata) === null || _round$roundMetadata3 === void 0 || (_round$roundMetadata3 = _round$roundMetadata3.quadraticFundingConfig) === null || _round$roundMetadata3 === void 0 ? void 0 : _round$roundMetadata3.minDonationThresholdAmount) !== null && _round$roundMetadata$ !== void 0 ? _round$roundMetadata$ : 1;
  const {
    address
  } = useAccount();
  const votingTokenForChain = useCartStorage(state => {
    var _props$roundCart$;
    return state.getVotingTokenForChain((_props$roundCart$ = props.roundCart[0]) === null || _props$roundCart$ === void 0 ? void 0 : _props$roundCart$.chainId);
  });
  const {
    data: matchingEstimates,
    error: matchingEstimateError,
    isLoading: matchingEstimateLoading
  } = useMatchingEstimates([{
    roundId: getFormattedRoundId((_round$id = round === null || round === void 0 ? void 0 : round.id) !== null && _round$id !== void 0 ? _round$id : zeroAddress),
    chainId: props.roundCart[0].chainId,
    potentialVotes: props.roundCart.map(proj => {
      var _round$id2, _votingTokenForChain$;
      return {
        roundId: getFormattedRoundId((_round$id2 = round === null || round === void 0 ? void 0 : round.id) !== null && _round$id2 !== void 0 ? _round$id2 : zeroAddress),
        projectId: proj.projectRegistryId,
        amount: parseUnits(typeof proj.amount === "string" && proj.amount !== "NaN" ? proj.amount : "0", (_votingTokenForChain$ = votingTokenForChain.decimals) !== null && _votingTokenForChain$ !== void 0 ? _votingTokenForChain$ : 18),
        grantAddress: proj.recipient,
        voter: address !== null && address !== void 0 ? address : zeroAddress,
        token: votingTokenForChain.address.toLowerCase(),
        applicationId: proj.grantApplicationId
      };
    })
  }]);
  const estimate = matchingEstimatesToText(matchingEstimates);
  const totalDonationInUSD = props.roundCart.reduce((acc, proj) => acc + Number(proj.amount), 0) * props.payoutTokenPrice;
  const showMatchingEstimate = matchingEstimateError === undefined && matchingEstimates !== undefined && (round === null || round === void 0 ? void 0 : round.chainId) !== 43114; // Avalanche

  return /*#__PURE__*/_jsxs("div", {
    className: "my-4",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "bg-grey-50 px-4 py-6 rounded-t-xl",
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex flex-row items-end justify-between",
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col",
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("p", {
              className: "text-xl font-semibold inline",
              children: round === null || round === void 0 || (_round$roundMetadata4 = round.roundMetadata) === null || _round$roundMetadata4 === void 0 ? void 0 : _round$roundMetadata4.name
            }), /*#__PURE__*/_jsxs("p", {
              className: "text-lg font-bold ml-2 inline",
              children: ["(", props.roundCart.length, ")"]
            })]
          }), minDonationThresholdAmount > 0 && /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsxs("p", {
              className: "text-sm pt-2 italic mb-5",
              children: ["Your donation to each project must be valued at", " ", minDonationThresholdAmount, " USD or more to be eligible for matching."]
            })
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        children: props.roundCart.map((project, key) => {
          var _matchingEstimates$fl;
          const matchingEstimateUSD = matchingEstimates === null || matchingEstimates === void 0 || (_matchingEstimates$fl = matchingEstimates.flat().find(est => {
            var _est$recipient, _project$recipient;
            return getAddress((_est$recipient = est.recipient) !== null && _est$recipient !== void 0 ? _est$recipient : zeroAddress) === getAddress((_project$recipient = project.recipient) !== null && _project$recipient !== void 0 ? _project$recipient : zeroAddress);
          })) === null || _matchingEstimates$fl === void 0 ? void 0 : _matchingEstimates$fl.differenceInUSD;
          return /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(ProjectInCart, {
              projects: props.roundCart,
              selectedPayoutToken: props.selectedPayoutToken,
              removeProjectFromCart: props.handleRemoveProjectFromCart,
              project: project,
              index: key,
              showMatchingEstimate: showMatchingEstimate,
              matchingEstimateUSD: matchingEstimateUSD,
              roundRoutePath: `/round/${props.roundCart[0].chainId}/${props.roundCart[0].roundId}`,
              last: key === props.roundCart.length - 1,
              payoutTokenPrice: props.payoutTokenPrice
            })
          }, key);
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "p-4 bg-grey-100 rounded-b-xl font-medium text-lg",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex flex-row justify-between items-center",
        children: [/*#__PURE__*/_jsx("div", {
          children: address && round && isSybilDefenseEnabled && /*#__PURE__*/_jsx("div", {
            "data-testid": "passport-widget",
            children: /*#__PURE__*/_jsx(PassportWidget, {
              round: round,
              alignment: "left"
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex flex-row gap-3 justify-center pt-1 pr-2",
          children: [/*#__PURE__*/_jsx("div", {
            children: showMatchingEstimate && /*#__PURE__*/_jsx("div", {
              className: "flex justify-end flex-nowrap",
              children: /*#__PURE__*/_jsx(Skeleton, {
                isLoaded: !matchingEstimateLoading,
                children: /*#__PURE__*/_jsxs("div", {
                  className: "flex flex-row font-semibold",
                  children: [/*#__PURE__*/_jsxs("div", {
                    className: "flex flex-col md:flex-row items-center gap-2 text-base",
                    children: [/*#__PURE__*/_jsx("span", {
                      className: "mr-2",
                      children: "Total match"
                    }), /*#__PURE__*/_jsxs("div", {
                      className: "flex flex-row items-center justify-between font-semibold text-teal-500",
                      children: [/*#__PURE__*/_jsx(BoltIcon, {
                        className: "w-4 h-4 inline"
                      }), "~$", estimate === null || estimate === void 0 ? void 0 : estimate.toFixed(2)]
                    })]
                  }), /*#__PURE__*/_jsx("span", {
                    className: "pl-4",
                    children: "|"
                  })]
                })
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "font-semibold",
            children: /*#__PURE__*/_jsxs("p", {
              children: [/*#__PURE__*/_jsx("span", {
                className: "mr-2",
                children: "Total donation"
              }), "$", isNaN(totalDonationInUSD) ? "0.0" : totalDonationInUSD.toFixed(2)]
            })
          })]
        })]
      })
    })]
  });
}